import { rgbToHex } from "@mui/material";
import { useState } from "react";

export interface ColorPickerProps {
    setChartColor: (value: string, index: number) => void;
    index: number;
    defaulColor?: string;
}

export const ColorPicker = (props: ColorPickerProps) => {
    const [color, setColor] = useState(props?.defaulColor ? rgbToHex(props?.defaulColor) : '#1569a8')

    const handleChange = (e: any) => {
        setColor(e?.target?.value)
        props.setChartColor(e?.target?.value, props?.index)
    };

    return (
        <div  >
            <input
                type="color"
                value={color}
                onChange={handleChange}
                className="hidden"
            />
        </div>
    )
}